export const baseApiUrl = '/api';
export const timeout = 60000;
